LS.location = {
	/**
	 * Get request location
	 *
	 * @param {Boolean} [international=false]
	 * @returns {Object}
	 */
	get(international) {
		const loc = $.context('request.location');

		return loc && (
			international ||
			loc.country === 'US'
		) ?
			loc : null;
	},

	/**
	 * Get request center
	 *
	 * @param {Boolean} [international=false]
	 * @returns {Array}
	 */
	center(international) {
		const loc = this.get(international);

		return loc ? [
			loc.longitude,
			loc.latitude
		] : null;
	},

	/**
	 * Parse location context
	 *
	 * @returns {Object}
	 */
	context() {
		const loc = $.context('location');

		if (! loc) {
			return null;
		}

		const obj = {
			[loc.type]: loc.slug
		};

		(loc.ancestors || []).forEach(ancestor => {
			obj[ancestor.type] = ancestor.slug;
		});

		return obj;
	},

	/**
	 * Fetch location data
	 *
	 * @param {String} slug
	 * @param {Function} fn
	 */
	entry(slug, fn) {
		LS.api.get('locations/' + slug, {
			proxy: true,
			flash: false,
			success: fn
		});
	},

	/**
	 * Format location heading
	 *
	 * @param {Object} value
	 * @param {Boolean} [suffix=false]
	 * @returns {*}
	 */
	heading(value, suffix) {
		if (! value) {
			return '';
		}

		let heading = value.name + (
			value.label ?
				' ' + value.label : ''
		);

		if (suffix) {
			heading += value.suffix ?
				', ' + value.suffix : '';
		}

		return heading;
	}
};